'use strict';

module.exports = require('./ColorPicker');
module.exports.Panel = require('./Panel');